var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1359 3.1665H20.1359C18.3678 3.1665 16.6721 3.86888 15.4219 5.11913C14.1716 6.36937 13.4692 8.06506 13.4692 9.83317V13.8332H9.46924V19.1665H13.4692V29.8332H18.8026V19.1665H22.8026L24.1359 13.8332H18.8026V9.83317C18.8026 9.47955 18.943 9.14041 19.1931 8.89036C19.4431 8.64031 19.7823 8.49984 20.1359 8.49984H24.1359V3.1665Z",
    stroke: "currentColor",
    strokeWidth: 2.74576,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.4f4ac6bea90405779a22df18d9c55943.svg";
export { ForwardRef as ReactComponent };